module.exports = __webpack_public_path__ + "static/media/cu.1c7fa110.svg";